module.exports = __webpack_public_path__ + "static/img/kaiyi.13d80d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/kaiyi.png
// module id = Utzi
// module chunks = 5